import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths";
import { AiOutlineLeft, AiOutlineRight } from "react-icons/ai";

const ServiceBottomButton = (props) => {
    const { selectedLanguage } = props

    const history = useHistory();
    const location = useLocation();
    const servicePaths = [
        allPaths?.DENTALSERVICE,
        allPaths?.AESTHETICSDENTISTRY,
        allPaths?.ENDODONTICDENTISTRY,
        allPaths?.ORALSURGERY,
        allPaths?.ORTHODONTICDENTISTRY,
        allPaths?.PROSTHODONTICDENTISTRY,
        allPaths?.PERIODONTALDENTISTRY,
        allPaths?.DENTALIMPLANTS,
        allPaths?.PEDODONTICDENTISTRY
    ];
    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const index = servicePaths.findIndex((path) => path === location.pathname);
        if (index !== -1) {
            setCurrentIndex(index);
        }
    }, [location.pathname, servicePaths]);

    const handleNext = () => {
        const nextIndex = (currentIndex + 1) % servicePaths.length;
        setCurrentIndex(nextIndex);
        history.push(servicePaths[nextIndex]);
    };

    const handlePrevious = () => {
        const prevIndex = (currentIndex - 1 + servicePaths.length) % servicePaths.length;
        setCurrentIndex(prevIndex);
        history.push(servicePaths[prevIndex]);
    };

    return (
        <div className="service-bottom-btn-main">
            <div className="service-bottom-btn-div">
                <button className="service-bottom-arrow-btn" onClick={handlePrevious}><AiOutlineLeft /></button>
                <button className="service-bottom-btn" onClick={() => history.push(allPaths?.SERVICE)}>{selectedLanguage?.txt_full_services}</button>
                <button className="service-bottom-arrow-btn" onClick={handleNext}><AiOutlineRight /></button>
            </div>
        </div>
    );
};

export default ServiceBottomButton;
